export default __webpack_public_path__ + "static/media/semi-conductor-factory.79f9bd8e.svg";